import { useNavigate } from 'react-router';

export function Menu() {
  const nav = useNavigate();
  return (
    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div className="menu">
        <div className="promo">
          <div className="badge">NEW</div>
          <div className="copy">
            <h2>
              FRIDAY <em>NIGHT</em>
              <br />
              SMACKDOWN
            </h2>
            <p>12-card showdown · cinematic mode</p>
          </div>
        </div>
        <div className="row">
          <button type="button" className="tile cpu" onClick={() => nav('/battle/cpu')}>
            <div className="num">01</div>
            <div>
              <div className="name">VS CPU</div>
              <div className="sub">Quick Match</div>
            </div>
          </button>
          <button type="button" className="tile friend" onClick={() => nav('/lobby')}>
            <div className="num">02</div>
            <div>
              <div className="name">VS FRIEND</div>
              <div className="sub">Coming Plan 2</div>
            </div>
          </button>
        </div>
        <button type="button" className="tile collection" onClick={() => nav('/collection')}>
          <div>
            <div className="name" style={{ color: 'var(--gold)' }}>COLLECTION</div>
            <div className="sub">12 / 12 superstars unlocked</div>
          </div>
          <div className="num">→</div>
        </button>
      </div>
    </div>
  );
}
